import React from "react";
import OSHAViolations from "./OSHAViolations/OSHAViolations";

const Safety = (props) => {
  return <OSHAViolations {...props} />;
};

export default Safety;
